// src/components/CardList.jsx
"use client";

/**
 * Consistent vertical stack for feed-style cards.
 * Keeps spacing + layout identical anywhere we show edge-to-edge cards.
 */
export default function CardList({ as: Component = "div", className = "", children }) {
  const classes = ["space-y-2", className].filter(Boolean).join(" ");
  return <Component className={classes}>{children}</Component>;
}
